/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import { MLGAFInfoService } from 'gw-capability-quoteandbind';
import { MLGAFInfoService as GatewayMLGAFInfoService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import _ from 'lodash';
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';

import metadata from './MLEmployersAffiliationsAccordionBodyComponent.metadata.json5';
import gatewayMetadata from './MLEmployersAffiliationsAccordionBodyComponentGateway.metadata.json5';
import styles from './MLEmployersAffiliationsAccordionBodyComponent.modules.scss';
import messages from './MLEmployersAffiliationsAccordionBodyComponent.messages';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';


function MLEmployersAffiliationsAccordionBodyComponent(props) {
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const {
        company,
        index,
        isOpen,
        selectOrganization,
        selectedPaypoint,
        quoteID,
        isGpa,
        sessionID,
        isEndorsement,
        searchText
    } = props;
    const consumerFacingComments = _.get(company, 'organizations[0].companyConsumerFacingComments', '');
    const agentFacingComments = _.get(company, 'organizations[0].companyARSPrompt', '');

    const [companyStateObj, setCompanyStateObj] = useState(company);
    const [commentsLimit, setCommentsLimit] = useState(45);
    const [selectedOrganization, setSelectedOrganization] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [selectedOrgCode, setSelectedOrgCode] = useState();

    const isQnb = appConfig.portalCode === 'QB';

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const showFullComments = () => {
        const fullLength = consumerFacingComments.length;
        setCommentsLimit(fullLength);
    };

    const formatStringToTitleCase = (str) => {
        return str
            .split(' ')
            .map((word) => word.length === 0 ? '' : word[0].toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    const highlightCurrentPaypoint = () => {
        if (selectedPaypoint && (selectedPaypoint.gpcCode === companyStateObj.gpcCode)) {
            companyStateObj.organizations.forEach((org) => {
                if (selectedPaypoint.paypointNumber === org.paypointNumber) {
                    setSelectedOrganization(org);
                }
            });
        }
    };

    const searchForPaypoints = () => {
        setIsLoading(true);
        let gafSearchByGpcPromise;
        if (isGpa) {
            gafSearchByGpcPromise = GatewayMLGAFInfoService.gpaSearchFilteredGAFByGPC(companyStateObj.gpcCode, quoteID, '', authHeader);
        } else if (isEndorsement) {
            gafSearchByGpcPromise = MLGAFInfoService.searchFilteredGAFByGPCForEndorsement(companyStateObj.gpcCode, quoteID, authHeader);
        } else {
            gafSearchByGpcPromise = MLGAFInfoService.searchFilteredGAFByGPC(companyStateObj.gpcCode, sessionID, quoteID);
            showProgressDialog(platformMessages.loading,gafSearchByGpcPromise,false,0);
        }
        gafSearchByGpcPromise.then((result) => {

            const gafInfos = _.filter(result.gafInfos, (gafData) => gafData.businessIndicator === true) || [];

            if (gafInfos && gafInfos.length > 0) {
                companyStateObj.organizations = gafInfos;
                highlightCurrentPaypoint();
            }
            setIsLoading(false);
        }).finally(() => {
            hideProgressDialog(true);
        }) 
    };

    const onPaypointSelected = (selectedVal) => {
        setSelectedOrgCode(selectedVal);
        const org = companyStateObj.organizations.find((o) => o.paypointNumber === selectedVal.code);
        setSelectedOrganization(org);
        selectOrganization(org);
    };

    useEffect(() => {
        if (isOpen && _.isUndefined(companyStateObj.organizations)) {
            searchForPaypoints();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    useEffect(() => {
        if (companyStateObj.organizations && companyStateObj.organizations.length > 0) {
            highlightCurrentPaypoint();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const viewDetails = (evt) => {
        const copyOfcompanyStateObj = _.cloneDeep(companyStateObj);
        copyOfcompanyStateObj.organizations = companyStateObj.organizations.map((o) => {
            o.viewDetails = false;
            return o;
        });
        const selectedOrg = copyOfcompanyStateObj.organizations[evt.index];
        selectedOrg.viewDetails = true;
        setCompanyStateObj(copyOfcompanyStateObj);
    };

    const searchResult = searchText.toLowerCase().replace(/'/g, '');

    const organizationInformation = ((companyStateObj?.organizations) &&
    // eslint-disable-next-line no-unsafe-optional-chaining
    (((companyStateObj?.organizations?.filter(org => org.companyName?.toLowerCase().includes((searchResult)))).length<1) &&
    // eslint-disable-next-line no-unsafe-optional-chaining
    (companyStateObj?.organizations?.filter(org =>org.paypointName?.toLowerCase().includes(searchResult))).length >= 1)) ?
    (companyStateObj?.organizations?.filter(org => org.paypointName?.toLowerCase().includes((searchResult)))) :
    (companyStateObj?.organizations);

    const generateOrganizationOverrides = () => {
        const orgs = _.get(companyStateObj, 'organizations', []);
        const organizations = (orgs.filter(org => org.companyName?.toLowerCase().includes((searchResult))).length<1 &&
        (orgs.filter(org =>org.paypointName?.toLowerCase().includes(searchResult))).length >= 1) ?
        (orgs.filter(org => org.paypointName?.toLowerCase().includes((searchResult)))) : orgs;
        const overrides = organizations.map((org, orgIndex) => {
            return {
                [`orgRepeatContent${index}${orgIndex}`]: {
                    className: org.paypointNumber === selectedOrganization.paypointNumber ? `ml-section slim vertical-spacing-15 blue-border ${isQnb ? 'qnbPadding10' : '' }` : `ml-section slim vertical-spacing-15 ${isQnb ? 'qnbPadding10' : '' }`
                },
                [`rowRadioInputCol${index}${orgIndex}`]: {
                    className: org.viewDetails ? 'padding-right-0 col-xs-12' : 'padding-right-0 col-xs-9'
                },
                [`accordionRadioInputDiv${index}${orgIndex}`]: {
                    availableValues: [{ code: org.paypointNumber, name: formatStringToTitleCase(org.paypointName) }],
                    value: selectedOrgCode,
                    onValueChange: onPaypointSelected
                },
                [`viewDetailsShowMobile${index}${orgIndex}`]: {
                    visible: !org.viewDetails && !isQnb
                },
                [`mobileDetailsRow${index}${orgIndex}`]: {
                    className: org.viewDetails ? 'show-mobile view-details padding-left-10 visible' : 'show-mobile view-details padding-left-10'
                },
                [`commentsHideMobile${index}${orgIndex}`]: {
                    visible: isQnb ? false : (!isGpa && !_.isEmpty(org.paypointCommentsConsumer)) || (isGpa && !_.isEmpty(org.paypointEligibilityComments))
                },
                [`paypointHideMobile${index}${orgIndex}`]: {
                    visible: !isQnb
                },
                [`mobileDetailsPaypointNumberP${index}${orgIndex}`]: {
                    visible: !isQnb
                },
                [`parentOrgRow${index}${orgIndex}`]: {
                    className: isQnb ? 'vertical-spacing-5 qnbColumnChange' : 'vertical-spacing-5'
                },
                [`payperiodHideMobileSpanLabel${index}${orgIndex}`]: {
                    className: isQnb ? 'font-weight-bold qnbDisplayNone' : 'font-weight-bold'
                },
                [`payperiodHideMobileSpanContent${index}${orgIndex}`]: {
                    className: isQnb ? 'qnbPadding45' : ''
                },
                [`payperiodHideMobile${index}${orgIndex}`]: {
                    className: isQnb ? 'padding-left-0 padding-right-10 qnbInheritDisplay' : 'hide-mobile padding-left-0 padding-right-10'
                },
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides = {
        [`consumerFacingCommentsDiv${index}`]: {
            visible: isQnb ? false : consumerFacingComments.length > 0
        },
        [`commentsHideMobileP${index}`]: {
            content: consumerFacingComments
        },
        [`showMobileCommentsSpanLimit${index}`]: {
            content: consumerFacingComments.substring(0, commentsLimit)
        },
        [`showMobileCommentsSpanDots${index}`]: {
            visible: commentsLimit < consumerFacingComments.length,
            content: translator(messages.dots)
        },
        [`commentsHelpText${index}`]: {
            visible: commentsLimit < consumerFacingComments.length
        },
        [`agentFacingCommentsContainer${index}`]: {
            visible: agentFacingComments.length > 0
        },
        [`agentComments${index}`]: {
            content: agentFacingComments
        },
        [`noOrgsSection${index}`]: {
            visible: isLoading
        },
        [`orgsRepeat${index}`]: {
            visible: companyStateObj.organizations && !isLoading,
            data: organizationInformation
        },
        ...generateOrganizationOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onClickShowFullComments: showFullComments,
            onViewDetails: viewDetails
        },
        resolveClassNameMap: styles
    };

    const metadataFile = isGpa ? gatewayMetadata : metadata;
    const updatedMetadata = appendMetadataWithIndex(metadataFile.componentContent, index);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLEmployersAffiliationsAccordionBodyComponent.propTypes = {
    index: PropTypes.number.isRequired,
    isOpen: PropTypes.bool.isRequired,
    company: PropTypes.shape({}),
    selectOrganization: PropTypes.func.isRequired,
    selectedPaypoint: PropTypes.shape({}),
    quoteID: PropTypes.string.isRequired,
    isGpa: PropTypes.bool.isRequired,
    sessionID: PropTypes.string.isRequired,
    isEndorsement: PropTypes.bool.isRequired,
    searchText: PropTypes.string
};

MLEmployersAffiliationsAccordionBodyComponent.defaultProps = {
    selectedPaypoint: {}
};


export default MLEmployersAffiliationsAccordionBodyComponent;
